<form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="d-flex">
  <div class="filter-element">
    <div ngbDropdown>
      <button type="button" class="btn btn-outline-primary" id="dropdownStatus" ngbDropdownToggle>
        <span class="fa-solid fa-filter"></span>
        <span translate>Filter</span>
      </button>
      <div aria-labelledby="dropdownManual" class="p-3" ngbDropdownMenu>
        <h6 class="dropdown-header px-0" translate>Show types</h6>
        <div class="checkbox-list">
          <div class="form-group form-check text-danger">
            <input class="form-check-input"
                   formControlName="F"
                   id="errorCheckbox"
                   type="checkbox">
            <label class="form-check-label" for="errorCheckbox">
              <span translate>Error</span>
              <span class="fa-solid fa-triangle-exclamation"></span>
            </label>
          </div>
          <div class="form-group form-check text-warning">
            <input class="form-check-input"
                   formControlName="W"
                   id="warningCheckbox"
                   type="checkbox">
            <label class="form-check-label" for="warningCheckbox">
              <span translate>Warning</span>
              <span class="fa-solid fa-circle-exclamation"></span>
            </label>
          </div>
          <div class="form-group form-check text-info">
            <input class="form-check-input"
                   formControlName="I"
                   id="infoCheckbox"
                   type="checkbox">
            <label class="form-check-label" for="infoCheckbox">
              <span translate>Info</span>
              <span class="fa-solid fa-circle-info"></span>
            </label>
          </div>
          <div class="form-group form-check text-debug">
            <input class="form-check-input"
                   formControlName="D"
                   id="debugCheckbox"
                   type="checkbox">
            <label class="form-check-label" for="debugCheckbox">
              <span translate>Debug</span>
              <span class="fa-solid fa-gear"></span>
            </label>
          </div>
          <div class="form-group form-check">
            <input class="form-check-input"
                   formControlName="IH"
                   id="inhibitCheckbox"
                   type="checkbox">
            <label class="form-check-label" for="inhibitCheckbox">
              <span translate>Inhibit</span>
              <span class="fa-solid fa-ban"></span>
            </label>
          </div>
        </div>
        <button type="submit" class="btn btn-block btn-primary" translate>Apply</button>
      </div>
    </div>
  </div>
  <button type="button" (click)="onUpdate()" class="btn btn-primary btn-block"
          [title]="'Apply' | translate">
    <span class="fa-solid fa-arrows-rotate"></span>
  </button>
</form>
